import { CSSProperties } from "react";
import { css } from "styled-components";

export const editButtonStyle = css`
	color: blue !important;

	svg path {
		fill: blue !important;
		stroke: blue !important;
	}

	&:focus,
	&:active {
		outline: none !important;
		box-shadow: none !important;
	}
`;

export const containerStyle: CSSProperties = {
	display: "inline-flex",
	alignItems: "center",
	gap: 8,
};

export const calendarWrapperStyle: CSSProperties = {
	position: "relative",
	zIndex: 1000,
	marginLeft: 2,
};

export const calendarContentStyle: CSSProperties = {
	position: "absolute",
	top: -8,
};

export const footerContainerStyle: CSSProperties = {
	display: "flex",
	justifyContent: "flex-start",
	gap: 8,
	padding: "8px 12px",
};
